<div id="camaraControls">
  <button (click)="show()" [ngClass]="{ disable: !camOpen }">
    <img src="../../../../assets/img/cam.png" alt="Icono camara" />
  </button>
  <button [ngClass]="{ disable: !camOpen, active: activeArrowBtn }" (click)="displayCamMenu()">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 640 640">
      <path
        d="M297.4 201.4C309.9 188.9 330.2 188.9 342.7 201.4L502.7 361.4C515.2 373.9 515.2 394.2 502.7 406.7C490.2 419.2 469.9 419.2 457.4 406.7L320 269.3L182.6 406.6C170.1 419.1 149.8 419.1 137.3 406.6C124.8 394.1 124.8 373.8 137.3 361.3L297.3 201.3z"
        fill="#fff" />
    </svg>
  </button>
  <div id="backgroundControls" [ngClass]="{ show: showBackgroundControls, hide: !showBackgroundControls}">
    <div class="row" *ngIf="isMedic">
      <button [ngClass]="{ disable: disabledImagenBtn }" (click)="clickFondoBtn('imagen')">
        <svg width="100%" height="100%" viewBox="0 0 64 56" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/"
          style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
          <g transform="matrix(1,0,0,1,-165.244746,-116.55415)">
            <g id="imagen" transform="matrix(1,0,0,1,46.900267,0)">
              <g transform="matrix(0.961538,0,0,0.759109,7.727356,27.982306)">
                <path
                  d="M115,173.7L115,122.9C115,119.5 117.2,116.7 120,116.7L175.7,116.7C178.4,116.7 180.6,119.5 180.6,122.9L180.6,173.7C180.6,177.2 178.4,180 175.7,180L170.4,180C170.1,178.7 169.6,177.5 169.1,176.2C169.3,176.1 169.5,176 169.8,176L175.7,176C176.7,176 177.5,175 177.5,173.7L177.5,122.9C177.5,121.7 176.7,120.6 175.7,120.6L120,120.6C119,120.6 118.2,121.7 118.2,122.9L118.2,173.7C118.2,175 119,176 120,176L125.8,176C126,176 126.2,176.1 126.5,176.2C125.9,177.5 125.5,178.7 125.1,180L120,180C117.2,180 115,177.2 115,173.7Z"
                  style="fill:#fff;" />
              </g>
              <path
                d="M156.1,152.6C164.8,155.5 170.3,164.2 170.3,170.5C170.3,171.3 169.6,172 168.8,172C168,172 167.3,171.3 167.3,170.5C167.3,164 160.2,154.5 149.7,154.5C139.2,154.5 132.4,163.9 132.4,170.5C132.4,171.3 131.7,172 130.9,172C130.1,172 129.4,171.3 129.4,170.5C129.4,164.2 134.7,155.5 143.4,152.6C139.2,150.3 136.3,145.9 136.3,140.7C136.3,133.3 142.3,127.3 149.7,127.3C157.1,127.3 163.1,133.3 163.1,140.7C163.1,145.9 160.3,150.3 156.1,152.6ZM149.7,130.3C144,130.3 139.3,135 139.3,140.7C139.3,146.5 144,151.2 149.7,151.2C155.5,151.2 160.1,146.5 160.1,140.7C160.1,135 155.5,130.3 149.7,130.3Z"
                style="fill:#fff;" />
              <g transform="matrix(1.043283,0,0,1.187568,-6.644604,-25.564449)">
                <path
                  d="M180.2,143L180.2,152.2C180.2,156.6 176.2,160.1 171.2,160.1L170.9,160.1C170.5,159.3 170.1,158.5 169.6,157.7C167.7,154.6 164.6,151.6 160.6,149.6C163.4,147.2 165.1,143.9 165.1,140.3L169.9,135.8C170.1,135.6 170.5,135.4 170.8,135.4C171.2,135.4 171.6,135.5 171.8,135.7L180.2,143ZM119.8,138.1L127.7,129.3C127.9,129 128.3,128.8 128.7,128.8C129.1,128.8 129.5,128.9 129.7,129.1L135.9,134.6C135.1,136.3 134.6,138.1 134.6,140C134.6,143.8 136.4,147.1 139.2,149.6C135.2,151.6 132.2,154.6 130.3,157.7C129.8,158.5 129.4,159.3 129.1,160.1L128.7,160.1C126.4,160.1 124.1,159.3 122.5,157.8C120.8,156.3 119.8,154.3 119.8,152.2L119.8,138.1Z"
                  style="fill:#fff;" />
              </g>
              <g transform="matrix(1.153205,0,0,1.153205,-29.161941,-18.112588)">
                <circle cx="167.6" cy="125.3" r="3.5" style="fill:#fff;" />
              </g>
            </g>
          </g>
        </svg>
      </button>
      <div class="values" #imagenValues>
        <button
          *ngFor="let valor of imagenValueBtns; let i = index"
          (click)="clickBtnValue('imagen', imagenValueBtn)"
          class="disable"
          [value]="valor"
          #imagenValueBtn
        >{{ i + 1 }}</button>
      </div>
    </div>
    <div class="row">
      <button [ngClass]="{ disable: disabledOfuscadoBtn }" (click)="clickFondoBtn('ofuscado')">
        <svg width="100%" height="100%" viewBox="0 0 64 56" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/"
          style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
          <g transform="matrix(1,0,0,1,-67.063521,-116.55415)">
            <g id="ofuscado" transform="matrix(1,0,0,1,9.235433,0)">
              <g transform="matrix(0.961538,0,0,0.759109,-52.789035,27.982306)">
                <path
                  d="M125.1,180L120,180C117.2,180 115,177.2 115,173.7L115,122.9C115,119.5 117.2,116.7 120,116.7L175.7,116.7C178.4,116.7 180.6,119.5 180.6,122.9L180.6,173.7C180.6,177.2 178.4,180 175.7,180L170.4,180C170,178.6 169.6,177.3 169,176L175.7,176C176.7,176 177.5,175 177.5,173.7L177.5,122.9C177.5,121.7 176.7,120.6 175.7,120.6L120,120.6C119,120.6 118.2,121.7 118.2,122.9L118.2,173.7C118.2,175 119,176 120,176L126.5,176C126,177.3 125.5,178.6 125.1,180Z"
                  style="fill:#fff;" />
              </g>
              <g transform="matrix(1,0,0,1,-60.516391,0)">
                <path
                  d="M156.1,152.6C164.8,155.5 170.3,164.2 170.3,170.5C170.3,171.3 169.6,172 168.8,172C168,172 167.3,171.3 167.3,170.5C167.3,164 160.2,154.5 149.7,154.5C139.2,154.5 132.4,163.9 132.4,170.5C132.4,171.3 131.7,172 130.9,172C130.1,172 129.4,171.3 129.4,170.5C129.4,164.2 134.7,155.5 143.4,152.6C139.2,150.3 136.3,145.9 136.3,140.7C136.3,133.3 142.3,127.3 149.7,127.3C157.1,127.3 163.1,133.3 163.1,140.7C163.1,145.9 160.3,150.3 156.1,152.6ZM149.7,130.3C144,130.3 139.3,135 139.3,140.7C139.3,146.5 144,151.2 149.7,151.2C155.5,151.2 160.1,146.5 160.1,140.7C160.1,135 155.5,130.3 149.7,130.3Z"
                  style="fill:#fff;" />
              </g>
              <g transform="matrix(1,0,0,1,-60.516391,0)">
                <g transform="matrix(0.660286,0,0,0.660286,42.988636,42.459117)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,42.988636,47.644128)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,42.988636,52.869449)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,42.988636,58.046766)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,42.988636,63.245019)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,42.988636,68.384168)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,42.988636,73.569179)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,63.728677,42.459117)">
                  <path
                    d="M124.3,125.5C124.3,125.3 124.3,125.2 124.3,125C124.3,123.7 125.3,122.7 126.5,122.7C127.7,122.7 128.7,123.6 128.8,124.8C127.3,124.9 125.8,125.1 124.3,125.5Z"
                    style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,53.358656,42.459117)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,53.358656,47.644128)">
                  <path
                    d="M126.2,127.2C125.1,127 124.3,126.1 124.3,125C124.3,123.7 125.3,122.7 126.5,122.7C127.5,122.7 128.4,123.4 128.7,124.2C127.8,125.2 126.9,126.2 126.2,127.2Z"
                    style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,53.358656,68.384168)">
                  <path
                    d="M128.5,126.1C128.1,126.8 127.4,127.2 126.5,127.2C125.3,127.2 124.3,126.2 124.3,125C124.3,124 124.9,123.1 125.8,122.8C126.6,124 127.5,125.1 128.5,126.1Z"
                    style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,74.098697,42.459117)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,84.453193,42.459117)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,84.453193,47.644128)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,84.453193,52.869449)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,84.453193,58.046766)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,84.453193,63.245019)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,84.453193,68.384168)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,84.453193,73.569179)">
                  <path
                    d="M124.4,125.8C124.3,125.5 124.3,125.3 124.3,125C124.3,123.7 125.3,122.7 126.5,122.7C127.8,122.7 128.8,123.7 128.8,125C128.8,126.2 127.8,127.2 126.5,127.2C126.2,127.2 125.8,127.1 125.5,127C125.2,126.6 124.8,126.2 124.4,125.8Z"
                    style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,48.173646,42.459117)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,48.173646,47.644128)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,48.173646,52.869449)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,48.173646,58.046766)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,48.173646,63.245019)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,48.173646,68.384168)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,48.173646,73.569179)">
                  <path
                    d="M127.2,127.1C127,127.2 126.8,127.2 126.5,127.2C125.3,127.2 124.3,126.2 124.3,125C124.3,123.7 125.3,122.7 126.5,122.7C127.8,122.7 128.8,123.7 128.8,125C128.8,125.1 128.8,125.2 128.8,125.4C128.2,125.9 127.7,126.5 127.2,127.1Z"
                    style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,68.913687,42.459117)">
                  <path
                    d="M124.3,124.8C124.4,123.7 125.4,122.7 126.5,122.7C127.8,122.7 128.8,123.7 128.8,125C128.8,125.2 128.8,125.4 128.7,125.6C127.3,125.2 125.8,124.9 124.3,124.8Z"
                    style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,58.543667,42.459117)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,79.283707,42.459117)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,79.283707,47.644128)">
                  <path
                    d="M124.3,124.6C124.5,123.5 125.4,122.7 126.5,122.7C127.8,122.7 128.8,123.7 128.8,125C128.8,126.2 127.8,127.2 126.5,127.2C126.5,127.2 126.5,127.2 126.5,127.2C125.8,126.3 125.1,125.4 124.3,124.6Z"
                    style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,79.283707,68.384168)">
                  <path
                    d="M126.9,122.8C128,122.9 128.8,123.9 128.8,125C128.8,126.2 127.8,127.2 126.5,127.2C125.6,127.2 124.8,126.7 124.5,125.9C125.4,124.9 126.2,123.9 126.9,122.8Z"
                    style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,89.638203,42.459117)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,89.638203,47.644128)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,89.638203,52.869449)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,89.638203,58.046766)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,89.638203,63.245019)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,89.638203,68.384168)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
                <g transform="matrix(0.660286,0,0,0.660286,89.638203,73.569179)">
                  <circle cx="126.5" cy="125" r="2.3" style="fill:#fff;" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>
      <div class="values" #ofuscadoValues>
        <button
          *ngFor="let valor of ofuscadoValueBtns; let i = index"
          (click)="clickBtnValue('ofuscado', ofuscadoValueBtn)"
          class="disable"
          [value]="valor"
          #ofuscadoValueBtn
        >{{ i + 1 }}</button>
      </div>
    </div>
  </div>
</div>